import React from 'react'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Dealers from '../../Componentz/Dealers'


const Fivemid = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
  return (
    <>
    <div class="container">
		<div class="FiveMarlaPP">
    <p>5 MARLA</p>
        <p>(30 lac PAYMENT PLAN)</p>
		</div>
		<div class="container">
      <div className="row">
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
				<div class="FiveMarlaPPOH" id="fTable">
				<p>5 MARLA</p>
                <p>(15 June-2021 MONTHLY PAYMENT PLAN)</p>
				</div>
				<div class="FMFTable">
					<p>&nbsp;</p>
					<table class="FiveMarlaPPTable text-center m-auto" >
          <tbody>
                        <tr id="FiveMarlaTr1">
                            <th>5 Marla Payment Plan</th>
                            <th>Monthly</th>
                        </tr>
                        <tr>
                            <td>Down Payment</td>
                            <td className='p-2'>600,000/-</td>
                        </tr>
                        <tr>
                            <td>10 OCT, 2021&nbsp; -To-&nbsp; 10 MAr, 2021</td>
                            <td className='p-2'>1% (30,000)</td>
                        </tr>
                        <tr>
                            <td>10-APR-2021</td>
                            <td className='p-2'>5%(150000)</td>
                        </tr>
                        <tr>
                            <td>10 MAY, 2021&nbsp; -To-&nbsp; 10 OCT, 2021</td>
                            <td className='p-2'>1% (30,000)</td>
                        </tr>
                        <tr>
                            <td>10-NOV-2021</td>
                            <td className='p-2'>5%(150000)</td>
                        </tr>
                        <tr>
                            <td>10 DEC, 2021&nbsp; -To- 10 MAY, 2022</td>
                            <td className='p-2'>1% (30,000)</td>
                        </tr>
                        <tr>
                            <td>10-JUN-2022</td>
                            <td className='p-2'>5%(150000)</td>
                        </tr>
                        <tr>
                            <td>10 JULY, 2022 -To-&nbsp; 10 DEC, 2022</td>
                            <td className='p-2'>1% (30,000)</td>
                        </tr>
                        <tr>
                            <td>10-JAN-2023</td>
                            <td className='p-2'>5% (150000)</td>
                        </tr>
                        <tr>
                            <td>10 FEB, 2023 -To-&nbsp; 10 JUN, 2023</td>
                            <td className='p-2'>1% (30,000)</td>
                        </tr>
                        <tr>
                            <td>10-JUL-2023</td>
                            <td className='p-2'>5% (150000)</td>
                        </tr>
                        <tr>
                            <td>10-AUG-2023</td>
                            <td className='p-2'>15% (450000)</td>
                        </tr>
                        <tr>
                            <td style={{color: "#fff", backgroundColor: "#165359"}}>Ballot Amount</td>
                            <td className='p-2'>11% (330000)-</td>
                        </tr>
                        <tr>
                            <td >TOTAL</td>
                            <td className='p-2'> 3,000,000.00-</td>
                        </tr>
                    </tbody>
					</table>
					<p>&nbsp;</p>
					<p style={{textAlign: "center", fontSize: "20px"}}>Total Installments: 36</p>
				</div>
			</div>
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
				<div class="FiveMarlaPPOH " id="">
                <p style={{color: "#921a1f"}}>5 MARLA</p>
                <p style={{color: "#921a1f"}}>(15 JUNE-2021 QUARTERLY PAYMENT PLAN)</p>
				</div>
				<div class="FMFTable">
					<p>&nbsp;</p>
					<table class="FiveMarlaPPTable2 text-center m-auto" >
              <tbody>
							<tr style={{border: "2px solid #921a1f", textAlign: "center", color: "#921a1f", height: "30px"}}>
                            <th>5 Marla Payment Plan</th>
                            <th>Quaterly</th>
                        </tr>
                        <tr>
                            <td>Down Payment</td>
                            <td className='p-2'>600,000/-</td>
                        </tr>
                        <tr>
                            <td>10-OCT-2020</td>
                            <td className='p-2'>3% (90000)</td>
                        </tr>
                        <tr>
                            <td>10-JAN-2021</td>
                            <td className='p-2'>3% (90000)</td>
                        </tr>
                        <tr>
                            <td>10-APR-2021</td>
                            <td className='p-2'>5%(150000)</td>
                        </tr>
                        <tr>
                            <td>10-MAY-2021</td>
                            <td className='p-2'>3% (90000)</td>
                        </tr>
                        <tr>
                            <td>10-AUG-2021</td>
                            <td className='p-2'>3% (90000)</td>
                        </tr>
                        <tr>
                            <td>10-NOV-2021</td>
                            <td className='p-2'>5%(150000)</td>
                        </tr>
                        <tr>
                            <td>10-DEC-2021</td>
                            <td className='p-2'>3% (90000)</td>
                        </tr>
                        <tr>
                            <td>10-MAR-2022</td>
                            <td className='p-2'>3% (90000)</td>
                        </tr>
                        <tr>
                            <td>10-JUN-2022</td>
                            <td className='p-2'>5%(150000)</td>
                        </tr>
                        <tr>
                            <td>10-JUL-2022</td>
                            <td className='p-2'>3% (90000)</td>
                        </tr>
                        <tr>
                            <td>10-OCT-2022</td>
                            <td className='p-2'>3% (90000)</td>
                        </tr>
                        <tr>
                            <td>10-JAN-2023</td>
                            <td className='p-2'>5%(150000)</td>
                        </tr>
                        <tr>
                            <td>10-FEB-2022</td>
                            <td className='p-2'>3% (90000)</td>
                        </tr>
                        <tr>
                            <td>10-MAY-2023</td>
                            <td className='p-2'>2%(60000)</td>
                        </tr>
                        <tr>
                            <td>10-JUL-2023</td>
                            <td className='p-2'>5%(150000)</td>
                        </tr>
                        <tr>
                            <td>10-AUG-2023</td>
                            <td className='p-2'>15% (450000)</td>
                        </tr>
                        <tr>
                            <td style={{color: "#fff", backgroundColor: "#921a1f"}}>Ballot Amount</td>
                            <td className='p-2'>11%(330000)-</td>
                        </tr>
                        <tr>
                            <td >TOTAL</td>
                            <td className='p-2'> 3,000,000.00-</td>
                        </tr>
                    </tbody>
					</table>
					<p>&nbsp;</p>
					<p style={{textAlign: "center", fontSize: "20px"}}>Total Installments:17</p>
				</div>
			</div>
      </div>
		</div>
		<div class="FiveMarlaPPNotes">
			<h1 style={{fontSize:"22px"}}>Note:</h1>
			<h5>1: Din Gardens will Charge 0.05% per day of total amount due as plenty if customer pays installment after due date which is 10th of every month. Furthermore the file is liable to cancel if thestomer fails to pay installment within 75 days from due date. Cancellation policy will apply.</h5>
			<h5>2: Ballot Amount will be due when balloting is announced by society.</h5>
			<h5>3: Possession Amount will be charged after last installment .</h5>
			<h5>4: All installments will be consider paid only when it will be debited in Din Properties’s bank account.</h5>
		</div>
		<div class="container">
      <div className="row my-3">
			<div class="col-lg-4 col-md-4 col-sm-4 col-xs-6">
				<div class="btn btn-primary FiveMarlaPPBtn m-1">
					<Link to="/SevenNew" className='Link'>7 Marla Payment Plan</Link>
				</div>
			</div>
			<div class="col-lg-4 col-md-4 col-sm-4 col-xs-6">
				<div class="btn btn-primary FiveMarlaPPBtn m-1">
					<Link to="/TenNew" className='Link'>10 Marla Payment Plan</Link>
				</div>
			</div>
			<div class="col-lg-4 col-md-4 col-sm-4 col-xs-12">
				<div class="btn btn-primary FiveMarlaPPBtn m-1">
					<Link to="/Kanal" className='Link'>1 Kanal Payment Plan</Link>
				</div>
			</div>
      </div>
		</div>
	</div>
   
  
    </>
  )
}

export default Fivemid